import React, { useState, useEffect, useRef } from 'react';
import ChangePasswordModal from './ChangePasswordModal';
import SettingsModal from './SettingsModal';

export default function AccountDropdown({ currentUser, onLogout }) {
  const [showMenu, setShowMenu]         = useState(false);
  const [showCpw, setShowCpw]           = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const wrapperRef              = useRef(null);

  useEffect(() => {
    if (!showMenu) return;
    const handler = (e) => {
      if (!wrapperRef.current?.contains(e.target)) setShowMenu(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [showMenu]);

  if (!currentUser) return null;

  const initials = currentUser.name
    ? currentUser.name.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase()
    : currentUser.email.slice(0, 2).toUpperCase();

  return (
    <>
      <div className="account-dropdown-wrapper" ref={wrapperRef}>
        <button
          className="account-avatar-btn"
          onClick={() => setShowMenu(m => !m)}
          aria-label="Account menu"
        >
          {initials}
        </button>

        {showMenu && (
          <div className="account-dropdown-menu">
            <div className="account-dropdown-user">
              <div className="account-dropdown-name">{currentUser.name || currentUser.email}</div>
              {currentUser.name && (
                <div className="account-dropdown-email">{currentUser.email}</div>
              )}
            </div>
            <hr className="account-dropdown-divider" />
            <button
              className="account-dropdown-item"
              onClick={() => { setShowMenu(false); setShowCpw(true); }}
            >
              Reset Password
            </button>
            <button
              className="account-dropdown-item"
              onClick={() => { setShowMenu(false); setShowSettings(true); }}
            >
              Settings
            </button>
            <hr className="account-dropdown-divider" />
            <button
              className="account-dropdown-item account-dropdown-logout"
              onClick={() => { setShowMenu(false); onLogout(); }}
            >
              Log Out
            </button>
          </div>
        )}
      </div>

      {showCpw && (
        <ChangePasswordModal
          userEmail={currentUser.email}
          required={false}
          onSuccess={() => setShowCpw(false)}
          onClose={() => setShowCpw(false)}
        />
      )}

      {showSettings && (
        <SettingsModal onClose={() => setShowSettings(false)} />
      )}
    </>
  );
}
